import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { ProjetoEquipeCapacidadeExecucaoService } from '../services/projeto-equipe-capacidade-execucao.service';

@Injectable({
  providedIn: 'root',
})
export class ProjetoEquipeResolver implements Resolve<boolean> {
  constructor(private service: ProjetoEquipeCapacidadeExecucaoService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.id);
  }
}

@Injectable({
  providedIn: 'root',
})
export class ProjetoEquipeResponsabilidadesResolver
  implements Resolve<boolean>
{
  constructor(private service: ProjetoEquipeCapacidadeExecucaoService) {}

  resolve(): Observable<any> {
    return this.service.getResponsabilidadesList();
  }
}
